import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import React, { useState, useEffect, useRef } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';
import { useDispatch, useSelector } from 'react-redux';
import { getRole, getUserName } from '../../../Redux/selecters';
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import Pagination from '../pagination/pagination';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import { FaFileCircleExclamation, FaPaperclip, FaEye, FaFileInvoiceDollar, FaShareFromSquare } from "react-icons/fa6";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { clearComparison } from '../../../Redux/actions/comparisonAction';

const REPORT_URL = process.env.REACT_APP_REPORTS_URL;
const ATTACHMENT_URL = process.env.REACT_APP_IMAGE_URL || "";

// Change this value to customize the comparison icon outline color.
const COMPARISON_ICON_COLOR = "#16A34A";

// API DocType values. Add/adjust a value here if the backend uses a different
// name for a document type. The grid itself remains completely dynamic.
const ATTACHMENT_DOC_TYPE_MAP = {
    "Purchase Requisition": "Requisition",
    "Requisition": "Requisition",
    "Price Comparison": "PriceComparison",
    "Quotation": "Quotation",
    "Purchase Order": "PurchaseOrder",
    "POrder": "PurchaseOrder",
    "GRN": "GRN",
    "Direct Purchase": "DirectPurchase",
    "Invoice": "Invoice",
    "Issue": "Issue",
    "Direct Issue": "Issue",
    "Store Request": "StoreRequest",
    "Purchase Return": "PurchaseReturn",
    "IReturn": "IssueReturn",
    "Issue Return": "IssueReturn",
    "IssueReceived": "IssueReceived",
    "Stock Adjustment": "StockAdjustment",
    "Stock Take": "StockAdjustment",
};

const getAttachmentDocType = (docType) => {
    if (!docType) return "";

    return ATTACHMENT_DOC_TYPE_MAP[docType] ||
        docType.toString().trim().replace(/\s+/g, "");
};

const Approval = () => {
    let navigate = useNavigate();
    const apiService = new ApiService();
    let dispatch = useDispatch()
    const [searchTerm, setSearchTerm] = useState({ value: 'Pending', label: 'Pending' });
    const [DocTerm, setDocTerm] = useState({ value: 'All', label: 'All' });
    const userName = useSelector(getUserName);
    const role = useSelector(getRole);
    const [rowData, setRowData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [loader, setloader] = useState(false);
    const [SupplierTab, setSupplierTab] = useState(true);
    const [permissions, setPermissions] = useState([]);
    const [POTab, setPOTab] = useState(true);
    const { currencyPrecision } = useCurrency();
    const gridRef = useRef();
    const [searchLoader, setLoader] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [forwardLevel3Modal, setForwardLevel3Modal] = useState(false);
    const [forwardingLevel3, setForwardingLevel3] = useState(false);
    const [canForwardToLevel3, setCanForwardToLevel3] = useState(false);

    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Approval");
        setPermissions(permissions[0]);

    }, []);
    const [formData, setFormData] = useState({
        DocType: "",
        fromDate: moment().format("YYYY-MM-DD"),          // Today's date
        toDate: moment().format("YYYY-MM-DD"),          // Today's date
        DocumentNo: "",
        filter: "",
    });
    const StatusFilter = [
        { value: 'All', label: 'All' },
        { value: 'Pending', label: 'Pending' },
        { value: 'Approved', label: 'Approved' },
        { value: 'Hold', label: 'Hold' },
        { value: 'Rejected', label: 'Rejected' },
    ];
    const DocFilter = [
        { value: 'All', label: 'All' },
        { value: 'Requisition', label: 'Purchase Requisition' },
        { value: 'Price Comparison', label: 'Price Comparison' },
        { value: 'Quotation', label: 'Quotation' },
        { value: 'POrder', label: 'Purchase Order' },
        { value: 'GRN', label: 'GRN' },
        { value: 'Direct Purchase', label: 'Direct Purchase' },
        { value: 'Invoice', label: 'Invoice' },
        { value: 'Purchase Return', label: 'Purchase Return' },
        { value: 'Issue', label: 'Issue item' },
        { value: 'Direct Issue', label: 'Direct Issue' },
        { value: 'IReturn', label: 'Issue Return' },
        { value: 'IssueReceived', label: 'Issue Received' },
        { value: 'Store Request', label: 'Store Request' },
        { value: 'Stock Adjustment', label: 'Stock Take' },
    ];
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate' || name === 'toDate') {
            const dateParts = e.target.value.split("-");
            if (dateParts[0].length > 4) {
                return;
            }
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const onGridReady = (params) => {
        gridRef.current = params.api;
        // params.api.showLoadingOverlay();
    };
    const fetchApprovalData = async (newPageNo = pagination?.currentPage) => {
        try {
            setLoader(true)
            gridRef.current?.showLoadingOverlay();
            const status = searchTerm?.value;
            let docType = DocTerm?.value.toString() || "All";
            if (docType === "Direct Issue") {
                docType = "Issue";
            } else if (docType === "POrder") {
                docType = "Purchase Order";
            }
            // Use the default dates if fromDate or toDate are not selected
            const fromDate = moment(formData.fromDate).format("DD-MMM-YY");
            const toDate = moment(formData.toDate).format("DD-MMM-YY");
            await checkLevel1Approver();

            if (fromDate === "Invalid date") {
                toast.warning("Please Select From Date")
                setLoader(false)
                gridRef.current?.hideOverlay();
                return
            } else if (toDate === "Invalid date") {
                toast.warning("Please Select To Date")
                setLoader(false)
                gridRef.current?.hideOverlay();
                return
            }
            if (docType === "All") {
                let param = `?UserName=${userName}&From=${fromDate}&To=${toDate}&Filter=${status || ""}&DocNo=${formData.DocumentNo}&PageNo=${1}&PageSize=${pageSize || 20}`;
                const response = await apiService.getApiParamater('GET_DOC_AUTHORIZATION_STATUS', param);
                if (response?.data?.statusCode === 200) {
                    const Authorization = response?.data?.result || [];
                    setRowData(Authorization);
                    setPagination(response.data.paginationData);
                    setLoader(false)
                    gridRef.current?.hideOverlay();
                } else if (response?.data?.statusCode === 204) {
                    setRowData([]);
                    setLoader(false)
                    gridRef.current?.hideOverlay();
                }
            } else {
                let param = `?Filter=${status || "Pending"}&From=${fromDate}&To=${toDate}&FilterBy=${docType}&UserName=${userName}&DocNo=${formData?.DocumentNo}&PageNo=${newPageNo || 1}&PageSize=${pageSize || 20}`;
                const response = await apiService.getApiParamater('GET_DOC_AUTHORIZATION_STATUS', param);
                if (response?.data?.statusCode === 200) {
                    const Authorization = response?.data?.result;
                    Authorization.sort((a, b) => b.docdate - a.docdate);
                    let AuthorizationData;
                    if (DocTerm?.label === 'Direct Issue') {
                        const res = await apiService.get('GET_ITEM_ISSUE');
                        const filteredRes = res.data.result?.filter(issue =>
                            Authorization.some(auth => auth.docno === issue.issueNo)
                        );
                        let filterAuthorization = filteredRes?.filter(issue => issue.requisitionNo === null);
                        const filteredAuth = Authorization?.filter(issue =>
                            filterAuthorization.some(auth => auth.issueNo === issue.docno)
                        );
                        AuthorizationData = filteredAuth;
                    } else {
                        AuthorizationData = Authorization;
                    }
                    setRowData(AuthorizationData || []);
                    setLoader(false)
                    gridRef.current?.hideOverlay();
                    setPagination(response.data.paginationData);
                } else if (response?.data?.statusCode === 204) {
                    setRowData([]);
                    setLoader(false)
                    gridRef.current?.hideOverlay();
                }
            }

        } catch (error) {
            console.error("Error fetching packing data:", error);
            setLoader(false)
            gridRef.current?.hideOverlay();
        }
    };
    const getData = async (newPageNo = pagination?.currentPage) => {
        try {
            gridRef.current?.showLoadingOverlay();
            const status = searchTerm?.value;
            let docType = DocTerm?.value.toString() || "All";
            if (docType === "Direct Issue") {
                docType = "Issue";
            } else if (docType === "POrder") {
                docType = "Purchase Order";
            }
            await checkLevel1Approver();

            // Use the default dates if fromDate or toDate are not selected
            const fromDate = formData.fromDate ? moment(formData.fromDate).format("DD-MMM-YY") : moment().format("DD-MMM-YY");
            const toDate = formData.toDate ? moment(formData.toDate).format("DD-MMM-YY") : moment().format("DD-MMM-YY");
            if (docType === "All") {
                let param = `?UserName=${userName}&From=${fromDate}&To=${toDate}&Filter=${status || ""}&DocNo=${formData.DocumentNo}&PageNo=${newPageNo || 1}&PageSize=${pageSize || 20}`;
                const response = await apiService.getApiParamater('GET_DOC_AUTHORIZATION_STATUS', param);
                if (response?.data?.statusCode === 200) {
                    const Authorization = response?.data?.result || [];
                    Authorization.sort((a, b) => b.docno - a.docno);
                    setRowData(Authorization);
                    setPagination(response.data.paginationData);
                    setLoader(false)
                    gridRef.current?.hideOverlay();
                } else if (response?.data?.statusCode === 204) {
                    setRowData([]);
                    setLoader(false)
                    gridRef.current?.hideOverlay();
                }
            } else {
                let param = `?Filter=${status || "Pending"}&From=${fromDate}&To=${toDate}&FilterBy=${docType}&UserName=${userName}&DocNo=${formData?.DocumentNo}&PageNo=${newPageNo || 1}&PageSize=${pageSize || 20}`;
                const response = await apiService.getApiParamater('GET_DOC_AUTHORIZATION_STATUS', param);
                if (response?.data?.statusCode === 200) {
                    const Authorization = response?.data?.result;
                    Authorization.sort((a, b) => b.docdate - a.docdate);
                    let AuthorizationData;
                    if (DocTerm?.label === 'Direct Issue') {
                        const res = await apiService.get('GET_ITEM_ISSUE');
                        const filteredRes = res.data.result?.filter(issue =>
                            Authorization.some(auth => auth.docno === issue.issueNo)
                        );
                        let filterAuthorization = filteredRes?.filter(issue => issue.requisitionNo === null);
                        const filteredAuth = Authorization?.filter(issue =>
                            filterAuthorization.some(auth => auth.issueNo === issue.docno)
                        );
                        AuthorizationData = filteredAuth;
                    } else {
                        AuthorizationData = Authorization;
                    }
                    setRowData(AuthorizationData.reverse());
                    setLoader(false)
                    gridRef.current?.hideOverlay();
                    setPagination(response.data.paginationData);
                } else if (response?.data?.statusCode === 204) {
                    setRowData([]);
                    setLoader(false)
                    gridRef.current?.hideOverlay();
                }
            }

        } catch (error) {
            console.error("Error fetching packing data:", error);
            setLoader(false)
            gridRef.current?.hideOverlay();
        }
    };
    const handleFilter = (selectedOption) => {
        setSearchTerm(selectedOption)
    };
    const handleDocFilter = (selectedOption) => {
        localStorage.setItem('selectedOptionLabel', selectedOption.label);
        setDocTerm(selectedOption);
    };
    const handleStatusSave = (event, row, status, rowNode) => {
        const { docno } = row;
        const isChecked = event.target.checked;

        setSelectedItems(prevItems => {
            const filteredItems = prevItems?.filter(item => item.docno !== docno);

            const newItem = {
                ...row,

                // Only one status can be selected
                approved: status === 'approved' && isChecked ? 1 : 0,
                hold: status === 'hold' && isChecked ? 1 : 0,
                rejected: status === 'rejected' && isChecked ? 1 : 0,

                higherAuthority:
                    status === 'higherAuthority' && isChecked ? 1 : 0
            };

            return [...filteredItems, newItem];
        });

        // Update only the affected AG Grid row. Replacing the complete rowData
        // array causes the grid to refresh and can jump the viewport back to the top.
        const updatedRow = {
            ...row,

            // Only one status can be selected
            approved: status === 'approved' && isChecked ? 1 : 0,
            hold: status === 'hold' && isChecked ? 1 : 0,
            rejected: status === 'rejected' && isChecked ? 1 : 0,

            higherAuthority:
                status === 'higherAuthority' && isChecked ? 1 : 0
        };

        if (rowNode && typeof rowNode.setData === 'function') {
            rowNode.setData(updatedRow);
        } else {
            // Safe fallback if the row node is unavailable.
            setRowData(prevRowData =>
                prevRowData.map(r => r.docno === docno ? updatedRow : r)
            );
        }
    };
    const handleStatusChange = async () => {
        let allSuccess = true;
        setloader(true)
        const initialDocType = DocTerm?.value.toString() || "Purchase Requisition";
        try {
            const apiService = new ApiService();
            for (const item of selectedItems) {
                if ((item.hold === 1 || item.rejected === 1) && (!item.remarks || item.remarks.trim() === "")) {
                    const action = item.hold === 1 ? "Hold" : "reject";
                    toast.error(`Please enter valid remarks to ${action} approval for ${item?.docno}`);
                    allSuccess = false;
                    setloader(false);
                    return;
                }
            }
            for (const item of selectedItems) {
                let statusValue;
                if (item.approved === 1) {
                    statusValue = 1;
                } else if (item.hold === 1) {
                    statusValue = 5;
                    if (!item.remarks) {
                        toast.error(`Please enter remarks to Hold approval for ${item?.docno}`);
                        allSuccess = false;
                        setloader(false)
                        return
                    }
                } else if (item.rejected === 1) {
                    statusValue = 2;
                    if (!item.remarks) {
                        toast.error(`Please enter remarks to reject approval for ${item?.docno}`);
                        allSuccess = false;
                        setloader(false)
                        return
                    }
                } else {
                    statusValue = 0;
                }
                let docType = initialDocType;
                if (docType === "Purchase Requisition") {
                    const res = await apiService.get('GET_PR');
                    const storeData = res?.data?.result?.filter(pr => pr?.requisitionNo === item?.docno);
                    if (storeData.length > 0) {
                        docType = "Store Request";
                    }
                }
                const body = {
                    docId: item?.docno,
                    srNo: item?.srNo,
                    docType: item.doctype === "Purchase Order" ? "POrder" : item.doctype,
                    status: statusValue,
                    userName: userName,
                    remarks: item.remarks || "",
                };

                const response = await apiService.put('UPDATE_DOC_AUTHORIZATION', body);
                if (response?.data?.statusCode === 201 || response.data.statusCode === 200) {
                    fetchApprovalData()
                    toast.success(`${item?.docno} ${statusValue === 1 ? "Approved" : statusValue === 5 ? "Hold" : statusValue === 2 ? "Rejected" : "Status Updated"}`);
                    setSelectedItems([]);
                    setloader(false)
                } else {
                    allSuccess = false;
                    setloader(false)
                }
            }

            if (allSuccess) {
                setSelectedItems([]);
                setloader(false)
            } else {
                console.error('Not all operations were successful.');
                setloader(false)
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message;
            const formattedMessage = errorMessage?.split('.')[0] + '.';
            toast.error(formattedMessage);
            setloader(false);
        }
    };
    // Attachment modal state
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [attachmentList, setAttachmentList] = useState([]);
    const [attachmentLoading, setAttachmentLoading] = useState(false);
    const [attachmentDocument, setAttachmentDocument] = useState(null);
    const [previewModal, setPreviewModal] = useState(false);
    const [sending, setSending] = useState(false);
    const [higherAuthorityModal, setHigherAuthorityModal] = useState(false);
    const [previewAttachment, setPreviewAttachment] = useState(null);

    const closeAttachmentModal = () => {
        setAttachmentModal(false);
        setAttachmentDocument(null);
        setAttachmentList([]);
    };

    const closePreviewModal = () => {
        setPreviewModal(false);
        setPreviewAttachment(null);
    };
    const checkLevel1Approver = async () => {
        try {
            const params = new URLSearchParams();
            params.append("UserNo", userName);
            params.append("DocType", "POrder");

            const response = await apiService.getApiParamater(
                "GET_APPROVAL_USER",
                `?${params.toString()}`
            );

            const result = response?.data?.result;

            const users = Array.isArray(result)
                ? result
                : result && typeof result === "object"
                    ? [result]
                    : [];

            const getValue = (item, possibleKeys) => {
                const key = Object.keys(item || {}).find(key =>
                    possibleKeys.includes(key.toLowerCase())
                );

                return key ? item[key] : undefined;
            };

            const normalizeUser = value =>
                String(value ?? "").trim().toLowerCase();

            const loggedInUser = normalizeUser(userName);

            const isLevel1Approver = users.some(item => {
                const apiUserNo = getValue(item, [
                    "userno",
                    "username",
                    "usernumber"
                ]);

                const apiUserLevel = getValue(item, [
                    "userlevel",
                    "level"
                ]);

                const apiActive = getValue(item, [
                    "active",
                    "isactive"
                ]);

                const level = parseInt(
                    String(apiUserLevel ?? "").match(/\d+/)?.[0],
                    10
                );

                const active = [
                    1,
                    true,
                    "1",
                    "true",
                    "active",
                    "yes",
                    "y"
                ].includes(
                    typeof apiActive === "string"
                        ? apiActive.trim().toLowerCase()
                        : apiActive
                );

                return (
                    normalizeUser(apiUserNo) === loggedInUser &&
                    level === 1 &&
                    active
                );
            });

            console.log("Logged-in User:", userName);
            console.log("GET_APPROVAL_USER Response:", result);
            console.log("Level 1 Approver:", isLevel1Approver);

            setCanForwardToLevel3(isLevel1Approver);

            return isLevel1Approver;

        } catch (error) {
            console.error("GET_APPROVAL_USER Error:", error);
            setCanForwardToLevel3(false);
            return false;
        }
    };
    const closeHigherAuthorityModal = () => {
        setHigherAuthorityModal(false);
    };

    const getAttachmentFileUrl = (fileName) => {
        if (!fileName) return "";
        return `${ATTACHMENT_URL}${encodeURIComponent(fileName)}`;
    };

    const handleAttachmentView = (attachment) => {
        if (!attachment?.fileName) {
            toast.warning("Attachment file is not available.");
            return;
        }

        setPreviewAttachment({
            ...attachment,
            url: getAttachmentFileUrl(attachment.fileName),
        });
        setPreviewModal(true);
    };

    const handleOpenAttachments = async (data) => {
        const docNo = data?.docno || data?.pOrderNo;
        const docType = getAttachmentDocType(data?.doctype);

        if (!docNo) {
            toast.warning("Document number is not available.");
            return;
        }

        if (!docType) {
            toast.warning("Document type is not available.");
            return;
        }

        try {
            setAttachmentDocument({ docNo, docType: data?.doctype || docType });
            setAttachmentList([]);
            setAttachmentLoading(true);
            setAttachmentModal(true);

            const attachParam = `?DocNo=${encodeURIComponent(docNo)}&DocType=${encodeURIComponent(docType)}`;
            const response = await apiService.getApiParamater("GET_ATTACHMENT", attachParam);

            const result = response?.data?.result;
            setAttachmentList(Array.isArray(result) ? result : []);

            if (!Array.isArray(result) || result.length === 0) {
                toast.info("No attachments found for this document.");
            }
        } catch (error) {
            console.error("Error fetching attachments:", error);
            setAttachmentList([]);
            toast.error("Unable to load document attachments.");
        } finally {
            setAttachmentLoading(false);
        }
    };

    const handleOpenHigherAuthorityModal = async (row) => {
        if (!row) {
            toast.error("Invalid purchase order.");
            return;
        }

        // Validate document type
        const isPurchaseOrder =
            row?.doctype === "Purchase Order" ||
            row?.doctype === "POrder" ||
            row?.orderType === "POrder";

        if (!isPurchaseOrder) {
            toast.error("Only Purchase Orders can be sent to higher authority.");
            return;
        }

        // Validate approval
        if (row?.approved !== 1) {
            toast.error("Purchase Order must be approved before sending to higher authority.");
            return;
        }

        // Validate document number
        if (!row?.docno) {
            toast.error("Purchase Order number is missing.");
            return;
        }

        try {
            setSending(true);

            const params = new URLSearchParams();
            params.append("DocType", row?.doctype || "");
            params.append("DocNo", row?.docno || "");

            const res = await apiService.getApiParamater(
                "GET_HIGHT_AUTHORITY_DOC",
                `?${params.toString()}`
            );

            const result = res?.data?.result;

            // Handle null / undefined / empty response
            const recordFound =
                result !== null &&
                result !== undefined &&
                (
                    (Array.isArray(result) && result.length > 0) ||
                    (!Array.isArray(result) && Object.keys(result || {}).length > 0)
                );

            if (recordFound) {
                toast.info(
                    `Document ${row.docno} has already been sent to higher authority.`
                );

                setHigherAuthorityModal(false);
                return;
            }

            // No existing record - open modal
            setSelectedRow(row);
            setHigherAuthorityModal(true);

        } catch (error) {
            console.error("GET_HIGHT_AUTHORITY_DOC error:", error);

            toast.error(
                error?.response?.data?.message ||
                "Unable to check higher authority status."
            );
        } finally {
            setSending(false);
        }
    };

    const sendToHigherAuthority = async () => {
        // -----------------------------
        // Basic validation
        // -----------------------------
        if (!selectedRow) {
            toast.error("No document selected.");
            return;
        }

        const isPurchaseOrder =
            selectedRow?.doctype === "Purchase Order" ||
            selectedRow?.doctype === "POrder" ||
            selectedRow?.orderType === "POrder";

        if (!isPurchaseOrder) {
            toast.error("Only Purchase Orders can be sent to higher authority.");
            return;
        }

        if (selectedRow?.approved !== 1) {
            toast.error(
                "Purchase Order must be approved before sending to higher authority."
            );
            return;
        }

        if (!selectedRow?.docno) {
            toast.error("Purchase Order number is missing.");
            return;
        }

        try {
            setSending(true);

            // -----------------------------
            // Check again before sending
            // Prevent duplicate submission
            // -----------------------------
            const checkParams = new URLSearchParams();
            checkParams.append("DocType", selectedRow?.doctype || "");
            checkParams.append("DocNo", selectedRow?.docno || "");

            const checkResponse = await apiService.getApiParamater(
                "GET_HIGHT_AUTHORITY_DOC",
                `?${checkParams.toString()}`
            );

            const existingRecord = checkResponse?.data?.result;

            const recordAlreadyExists =
                existingRecord !== null &&
                existingRecord !== undefined &&
                (
                    (Array.isArray(existingRecord) &&
                        existingRecord.length > 0) ||
                    (!Array.isArray(existingRecord) &&
                        Object.keys(existingRecord || {}).length > 0)
                );

            if (recordAlreadyExists) {
                toast.info(
                    `Document ${selectedRow.docno} has already been sent to higher authority.`
                );

                setHigherAuthorityModal(false);
                return;
            }

            // -----------------------------
            // Send to higher authority
            // -----------------------------
            const body = {
                docType: selectedRow?.doctype,
                docNo: selectedRow?.docno,
                sendToManagement: true,
                remarks: selectedRow?.remarks || "",
                exp1: "",
                exp2: "",
                exp3: "",
                exp4: "",
                exp5: ""
            };

            const response = await apiService.post(
                "POST_HIGHT_AUTHORITY_DOC",
                body
            );

            const statusCode = response?.data?.statusCode;

            if (statusCode === 200 || statusCode === 201) {
                toast.success(
                    `Document ${selectedRow.docno} sent to higher authority successfully.`
                );

                setHigherAuthorityModal(false);
                setSelectedRow(null);

                fetchApprovalData();
            } else {
                toast.error(
                    response?.data?.message ||
                    `Failed to send document ${selectedRow.docno} to higher authority.`
                );
            }

        } catch (error) {
            console.error("POST_HIGHT_AUTHORITY_DOC error:", error);

            toast.error(
                error?.response?.data?.message ||
                "Error while sending document to higher authority."
            );
        } finally {
            setSending(false);
        }
    };
    const closeForwardLevel3Modal = () => {
        if (!forwardingLevel3) {
            setForwardLevel3Modal(false);
            setSelectedRow(null);
        }
    };

    const handleOpenForwardLevel3Modal = (row) => {
        const isPurchaseOrder =
            row?.doctype === "Purchase Order" ||
            row?.doctype === "POrder" ||
            row?.orderType === "POrder";

        if (
            !isPurchaseOrder ||
            Number(row?.approved) !== 1 ||
            !canForwardToLevel3
        ) {
            toast.warning(
                "Only the Level 1 approver can forward an approved Purchase Order to the 3rd level."
            );
            return;
        }

        if (!row?.docno) {
            toast.warning("Purchase Order number is missing.");
            return;
        }

        setSelectedRow(row);
        setForwardLevel3Modal(true);
    };

    const forwardPurchaseOrderToLevel3 = async () => {
        if (!selectedRow?.docno) {
            toast.error("Purchase Order number is missing.");
            return;
        }

        try {
            setForwardingLevel3(true);
            const params = new URLSearchParams();
            params.append("DocNo", selectedRow.docno);
            params.append("Action", "UpdateLevel2PODocumentByDocNo");
            params.append("Commontext", `Auto Approved by ${userName || ""}`);

            const response = await apiService.getApiParamater(
                "GET_REQ_COMMON",
                `?${params.toString()}`
            );
            debugger
            if (response?.data?.statusCode === 200 && response?.data?.isSuccessful === true) {
                toast.success(response?.data?.message || "Purchase Order forwarded for 3rd-level approval successfully.");
                setForwardLevel3Modal(false);
                setSelectedRow(null);
                await fetchApprovalData();
            } else {
                toast.error(response?.data?.message || "Purchase Order could not be forwarded for 3rd-level approval.");
            }
        } catch (error) {
            console.error("GET_REQ_COMMON 3rd-level forwarding error:", error);
            toast.error(
                error?.response?.data?.message ||
                "An error occurred while forwarding the Purchase Order for 3rd-level approval."
            );
        } finally {
            setForwardingLevel3(false);
        }
    };

    const colDefs = [
        { headerName: "Doc Type", field: "doctype", suppressMovable: true, width: 150 },
        {
            headerName: "Action",
            field: "action",
            suppressMovable: true,
            width: 125,
            sortable: false,
            filter: false,
            cellRenderer: (params) => {
                const hasPcNo = params.data?.pcNo !== null &&
                    params.data?.pcNo !== undefined &&
                    String(params.data.pcNo).trim() !== "";
                const iconButtonStyle = {
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    fontSize: "18px",
                    padding: "8px",
                    display: "inline-flex",
                    alignItems: "center",
                };
                return (
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <button
                            type="button"
                            title="View attachments"
                            aria-label="View attachments"
                            onClick={() => handleOpenAttachments(params.data)}
                            style={iconButtonStyle}
                        >
                            <FaPaperclip />
                        </button>
                        {hasPcNo && (
                            <button
                                type="button"
                                title="View comparison"
                                aria-label="View comparison"
                                onClick={() => handleComparisionView(params.data, params.data.pcNo)}
                                style={iconButtonStyle}
                            >
                                <FaFileInvoiceDollar
                                    size={20}
                                    style={{
                                        color: COMPARISON_ICON_COLOR,
                                        fill: "transparent",
                                        stroke: COMPARISON_ICON_COLOR,
                                        strokeWidth: 18,
                                    }}
                                />
                            </button>
                        )}
                        {canForwardToLevel3 &&
                            Number(params.data?.approved) === 1 &&
                            ["Purchase Order", "POrder"].includes(params.data?.doctype) && (
                                <button
                                    type="button"
                                    title="Forward to 3rd-level approval"
                                    aria-label="Forward to 3rd-level approval"
                                    onClick={() => handleOpenForwardLevel3Modal(params.data)}
                                    style={{ ...iconButtonStyle, color: "#2563EB" }}
                                >
                                    <FaShareFromSquare size={19} />
                                </button>
                            )}
                    </div>
                );
            },
        },
        {
            headerName: "Doc No", field: "docno", suppressMovable: true, width: 150,
            cellRenderer: (params) => {
                const { doctype } = params.data;
                const handleButtonClick = () => handleDocumentPrint(params.data);
                const buttonStyle = {
                    color: '#1032E7',
                    textDecoration: "underline",
                    border: "none",
                    backgroundColor: "#fff"
                };
                if (doctype === "Purchase Requisition") {
                    return <button style={buttonStyle} onClick={handleButtonClick}>{params.value}</button>;
                } else if (doctype === "Price Comparison") {
                    return <button style={buttonStyle} onClick={handleButtonClick}>{params.value}</button>;
                } else if (doctype === "Quotation") {
                    return <button style={buttonStyle} onClick={handleButtonClick}>{params.value}</button>;
                } else if (doctype === "Purchase Order") {
                    return <button style={buttonStyle} onClick={handleButtonClick}>{params.value}</button>;
                } else if (doctype === "GRN") {
                    return <button style={buttonStyle} onClick={handleButtonClick}>{params.value}</button>;
                } else if (doctype === "Direct Purchase") {
                    return <button style={buttonStyle} onClick={handleButtonClick}>{params.value}</button>;
                } else if (doctype === "Invoice") {
                    return <button style={buttonStyle} onClick={handleButtonClick}>{params.value}</button>;
                } else if (doctype === "Issue") {
                    return <button style={buttonStyle} onClick={handleButtonClick}>{params.value}</button>;
                } else if (doctype === "Store Request") {
                    return <button style={buttonStyle} onClick={handleButtonClick}>{params.value}</button>;
                } else if (doctype === "Purchase Return") {
                    return <button style={buttonStyle} onClick={handleButtonClick}>{params.value}</button>;
                } else {
                    return <button style={buttonStyle} onClick={handleButtonClick}>{params.value}</button>;
                }
            }
        },
        {
            headerName: "Date", field: "docdate", suppressMovable: true, width: 150
        },
        {
            headerName: "Amount", field: "amount", suppressMovable: true, width: 120,
            valueFormatter: (params) => params?.value?.toFixed(currencyPrecision?.exp1 || 0)
        },
        {
            headerName: "Approved", field: "approved", editable: false, suppressMovable: true, width: 120,
            cellRenderer: (params) => (
                <input
                    type="checkbox"
                    style={{ width: "26.81px", height: "26.81px", border: "0.5px solid #5B93FF" }}
                    checked={params.data.approved === 1}
                    onChange={(event) => handleStatusSave(event, params.data, 'approved', params.node)}
                />
            )
        },
        {
            headerName: "Hold", field: "hold", editable: false, suppressMovable: true, width: 120,
            cellRenderer: (params) => (
                <input
                    type="checkbox"
                    style={{ width: "26.81px", height: "26.81px", border: "0.5px solid #5B93FF" }}
                    checked={params.data.hold === 1}
                    onChange={(event) => handleStatusSave(event, params.data, 'hold', params.node)}
                />
            )
        },
        {
            headerName: "Reject", field: "rejected", editable: false, suppressMovable: true, width: 120,
            cellRenderer: (params) => (
                <input
                    style={{ width: "26.81px", height: "26.81px", border: "0.5px solid #5B93FF" }}
                    type="checkbox"
                    checked={params.data.rejected === 1}
                    onChange={(event) => handleStatusSave(event, params.data, 'rejected', params.node)}
                />
            )
        },
        {
            headerName: "Higher Authority",
            field: "higherAuthority",
            editable: false,
            suppressMovable: true,
            width: 200,
            cellRenderer: (params) => {
                const isPurchaseOrder =
                    params.data?.doctype === "POrder" ||
                    params.data?.doctype === "Purchase Order" ||
                    params.data?.orderType === "POrder";

                const isApproved = params.data?.approved === 1;
                const isRole = role === "Admin" || role === "Super Admin";
                if (!isPurchaseOrder || !isApproved || !isRole) {
                    return null;
                }

                return (
                    <div>
                        <button
                            className="mainbtn"
                            type="button"
                            style={{
                                cursor: "pointer",
                                display: "flex",
                                padding: "0px 10px",
                                alignItems: "center",
                            }}
                            disabled={sending}
                            onClick={() =>
                                handleOpenHigherAuthorityModal(params.data)
                            }
                        >
                            <div>Send to top Authority</div>
                        </button>
                    </div>
                );
            }
        },
        { headerName: "Remarks", field: "remarks", editable: true, suppressMovable: true, width: 120 },
        { headerName: "Modified By", field: "modifiedBy", suppressMovable: true, width: 180 },
        { headerName: "Cost Center 1", field: "costCentre1", suppressMovable: true, width: 130 },
        { headerName: "Cost Center 2", field: "costCentre2", suppressMovable: true, width: 130 },
        { headerName: "Currency", field: "currency", suppressMovable: true, width: 120 },
        { headerName: "Terms", field: "terms", suppressMovable: true, width: 120 },
        { headerName: "Created On", field: "modifiedOn", suppressMovable: true, width: 130 },
        { headerName: "Department", field: "department", suppressMovable: true, width: 130 },
        { headerName: "Order Type", field: "orderType", suppressMovable: true, width: 130 },
        { headerName: "User", field: "userName", suppressMovable: true, width: 150 }
    ];
    // One report-print handler for all supported document types.
    const handleDocumentPrint = (data) => {
        const docType = (data?.doctype || "").trim();
        const reportTypeByDocument = {
            "Purchase Requisition": "PurchaseRequisition",
            "Requisition": "PurchaseRequisition",
            "Price Comparison": "PriceComparison",
            "Quotation": "PriceComparison",
            "Purchase Order": "POrder",
            "POrder": "POrder",
            "GRN": "GRN",
            "Direct Purchase": "DirectPurchase",
            "Invoice": "Invoice",
            "Issue": "Issue",
            "Direct Issue": "Issue",
            "Purchase Return": "PurchaseReturn",
            "Store Request": "PurchaseRequisition",
            "Issue Return": "IssueReturn",
            "IReturn": "IssueReturn",
            "IssueReceived": "IssueReceived",
            "Stock Adjustment": "StockAdjustment",
            "Stock Take": "StockAdjustment",
        };

        const reportType = reportTypeByDocument[docType];
        if (!reportType) {
            toast.warning(`Print is not configured for ${docType || "this document type"}.`);
            return;
        }

        handlePrint(reportType, data?.docno);
    };

    // The comparison eye opens the comparison view using pcNo (not docno).
    const handleComparisionView = (data, pcNo = data?.pcNo) => {
        if (pcNo === null || pcNo === undefined || String(pcNo).trim() === "") {
            toast.warning("Price Comparison number is not available.");
            return;
        }

        let reportType = 'PriceComparison'
        let docno = data?.pcNo
        debugger
        handlePrint(reportType, docno);

        // dispatch(clearComparison());
        // navigate(`/Inventory/PriceComparison/View/${encodeURIComponent(pcNo)}`, {
        //     state: { ...data, pcNo },
        // });
    };

    const handleRemarks = (event) => {
        const editedRow = rowData.find(row => row.docno === event.data.docno);
        if (editedRow) {
            editedRow[event.colDef.field] = event.value;

            setSelectedItems(prevItems => {
                const updatedItems = [...prevItems];
                const existingItemIndex = updatedItems.findIndex(item => item.docno === editedRow.docno);

                if (existingItemIndex !== -1) {
                    updatedItems[existingItemIndex] = {
                        ...updatedItems[existingItemIndex],
                        [event.colDef.field]: event.value,
                    };
                } else {
                    updatedItems.push({ ...editedRow });
                }

                return updatedItems;
            });
        }
    };
    const handleBackClick = () => {
        window.history.back();
    };
    const handleReset = () => {
        setSelectedItems([]);
        setloader(false)
        setFormData({
            DocType: "",
            fromDate: moment().format("YYYY-MM-DD"),
            toDate: moment().format("YYYY-MM-DD"),
            DocumentNo: "",
            filter: '',
        });
        setSearchTerm({ value: 'Pending', label: 'Pending' });
        setDocTerm({ value: 'All', label: 'All' });
    };
    const handlePrint = (reportType, docNo) => {
        if (docNo) {
            // dispatch(clearRows());
            const token = localStorage.getItem('Token');
            const DB = localStorage.getItem('DataBase');
            if (!token) {
                alert('Auth token is missing! Unable to proceed.');
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open('', 'ReportPopup', `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`);

            if (popup) {
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = REPORT_URL;
                form.target = 'ReportPopup';

                const inputs = [
                    { name: 'authToken', value: token },
                    { name: '_db', value: DB },
                    { name: 'reportName', value: reportType },
                    { name: 'voucherNo', value: docNo },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
            // navigate(`/Inventory/Purchase/Order/${selectedRow?.recordId}`, { state: selectedRow })
        }
    };
    return (
        <div className='px-4 mt-4'>
            {/* Attachments modal - data is loaded only when the grid icon is clicked */}
            {attachmentModal && (
                <div
                    className="modal d-block"
                    tabIndex="-1"
                    role="dialog"
                    style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1055 }}
                >
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Attachments — {attachmentDocument?.docNo || ""}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={closeAttachmentModal}
                                />
                            </div>

                            <div className="modal-body">
                                <div className="d-flex justify-content-between mb-3">
                                    <div>
                                        <strong>Document No:</strong> {attachmentDocument?.docNo || "-"}
                                    </div>
                                    <div>
                                        <strong>Document Type:</strong> {attachmentDocument?.docType || "-"}
                                    </div>
                                </div>

                                {attachmentLoading ? (
                                    <div className="d-flex justify-content-center py-5">
                                        <ClipLoader size={35} />
                                    </div>
                                ) : attachmentList.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-bordered align-middle mb-0">
                                            <thead>
                                                <tr>
                                                    <th>File Name</th>
                                                    <th>Remarks</th>
                                                    <th style={{ width: "100px" }}>View</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {attachmentList.map((attachment, index) => (
                                                    <tr key={attachment?.id || attachment?.fileName || index}>
                                                        <td>{attachment?.fileName || "-"}</td>
                                                        <td>{attachment?.remarks || "-"}</td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                className="mainbtnRed"
                                                                disabled={!attachment?.fileName}
                                                                onClick={() => handleAttachmentView(attachment)}
                                                                title="View attachment"
                                                            >
                                                                <FaEye />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="text-center py-5 text-muted">
                                        No attachments found.
                                    </div>
                                )}
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="mainbtn" onClick={closeAttachmentModal}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* File preview modal */}
            {previewModal && (
                <div
                    className="modal d-block"
                    tabIndex="-1"
                    role="dialog"
                    style={{ backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1060 }}
                >
                    <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Preview — {previewAttachment?.fileName || "Attachment"}
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={closePreviewModal}
                                />
                            </div>
                            <div className="modal-body" style={{ minHeight: "500px" }}>
                                {(() => {
                                    const fileName = previewAttachment?.fileName || "";
                                    const extension = fileName.split(".").pop()?.toLowerCase();
                                    const url = previewAttachment?.url;
                                    const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];

                                    if (imageExtensions.includes(extension)) {
                                        return (
                                            <div className="text-center">
                                                <img
                                                    src={url}
                                                    alt={fileName}
                                                    style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain" }}
                                                />
                                            </div>
                                        );
                                    }

                                    if (extension === "pdf") {
                                        return (
                                            <iframe
                                                src={url}
                                                title={fileName}
                                                style={{ width: "100%", height: "70vh", border: "none" }}
                                            />
                                        );
                                    }

                                    return (
                                        <div className="text-center py-5">
                                            <p>Preview is not available for this file type.</p>
                                            <a
                                                href={url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="mainbtn d-inline-flex text-decoration-none"
                                            >
                                                Open File
                                            </a>
                                        </div>
                                    );
                                })()}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Level 1 Purchase Order forwarding confirmation */}
            <Modal show={forwardLevel3Modal} onHide={closeForwardLevel3Modal} centered>
                <Modal.Header closeButton={!forwardingLevel3}>
                    <Modal.Title>Forward Purchase Order</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to forward Purchase Order <strong>{selectedRow?.docno}</strong> for 3rd-level approval?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeForwardLevel3Modal} disabled={forwardingLevel3}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={forwardPurchaseOrderToLevel3} disabled={forwardingLevel3}>
                        {forwardingLevel3 ? "Forwarding..." : "Yes, Forward"}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* File preview modal */}
            {higherAuthorityModal && (
                <Modal show={higherAuthorityModal} onHide={closeHigherAuthorityModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Send to Higher Authority</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to send this {selectedRow?.docno || selectedRow?.docNo} to higher authority?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeHigherAuthorityModal} disabled={sending}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={sendToHigherAuthority} disabled={sending}>
                            {sending ? 'Sending...' : 'Send'}
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            <div className="cost-center-section">
                <div className='border-box2 p-4 d-flex justify-content-between pt-3'>
                    <h5 className='col mainInvHead'>Approvals</h5>
                    <div className='d-flex gap-3'>
                        {loader === true ?
                            <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                            <>
                                {permissions?.canUpdate === true ?
                                    <button className='mainbtn ' type="submit" onClick={handleStatusChange}><FaSave className='center mt-1 mx-2' /><div>Save</div></button>
                                    : ''
                                }
                            </>
                        }
                        <button className='mainbtnRed' onClick={handleReset} ><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                        <button onClick={handleBackClick} className='mainbtn'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                    </div>
                </div>
                <div className="d-flexcursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Approval Filters</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group row pb-3">
                            <div className="d-flex justify-content-between col-md-4 col-lg-4 ">
                                <label htmlFor="validationCustom02" className="form-label  pt-1 start">Document No</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    id="validationCustom02"
                                    name="DocumentNo"
                                    value={formData?.DocumentNo}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="d-flex justify-content-between col-md-4 col-lg-4">
                                <label htmlFor="validationCustom02" className="form-label  pt-1 start">Filter</label>
                                <Select
                                    value={searchTerm}
                                    options={StatusFilter}
                                    onChange={handleFilter}
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                            <div className="d-flex justify-content-between col-md-4 col-lg-4">
                                <label htmlFor="validationCustom01" className="form-label  pt-1 start">Document Type</label>
                                <Select
                                    value={DocTerm}
                                    options={DocFilter}
                                    onChange={handleDocFilter}
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <div className="d-flex justify-content-between start col-md-4 col-lg-4">
                                <label htmlFor="validationCustom02" className="form-label  pt-1 start">From Date</label>
                                <DatePicker
                                    selected={formData.fromDate}
                                    onChange={(date) =>
                                        setFormData({
                                            ...formData,
                                            fromDate: date,
                                        })
                                    }
                                    className="p-2 form-Input w-100"
                                    dateFormat="dd-MM-yyyy"
                                />
                            </div>
                            <div className="d-flex justify-content-between start col-md-4">
                                <label htmlFor="validationCustom02" className="form-label  pt-1 start">To Date</label>
                                <DatePicker
                                    selected={formData.toDate}
                                    onChange={(date) =>
                                        setFormData({
                                            ...formData,
                                            toDate: date,
                                        })
                                    }
                                    className="p-2 form-Input w-100"
                                    dateFormat="dd-MM-yyyy"
                                />
                            </div>
                            <div className='col d-flex gap-3'>
                                <div className='w-50'>
                                    {searchLoader === true ?
                                        <button className='mainbtnGry w-100 ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                                        <div onClick={() => fetchApprovalData()} className='mainbtnGry flex-end gap-2'>
                                            <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                            <div className='center'>Search</div>
                                        </div>
                                    }
                                </div>
                                <div className='w-50'>
                                    <div onClick={() => handleReset()} className='mainbtnRed flex-end  gap-2'>
                                        <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                                        <div className='center'>Reset</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>Approval List</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 ${SupplierTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="ag-theme-quartz" style={{ height: 500, suppressMovable: true, width: '100%' }}>
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={colDefs}
                                onGridReady={onGridReady}
                                onCellValueChanged={handleRemarks}
                                suppressRowClickSelection={true}
                                getRowStyle={(params) => {
                                    return params.node.rowIndex % 2 === 0
                                        ? { background: '#F0EDF5' }
                                        : { background: '#fff' };
                                }}
                            />
                        </div>
                        <Pagination pagination={pagination} getItems={getData} pageSize={pageSize} />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Approval;
